import type { ConversationAttachment as ConversationAttachmentType } from '@kimuno/api-sdk/lib/types/responses/Ai';
import { Stack } from '@mui/material';
import React from 'react';

import { spaces } from '../../../../../assets/styles/themes/tokens';
import AIUploadFile from './AIUploadFile';

export type ConversationAttachmentHashName = ConversationAttachmentType['hashName'];

const AIUploadFileList: React.FC<{
	uploadedAttachments: ConversationAttachmentHashName[];
	withRemoveButton?: boolean;
}> = ({ uploadedAttachments, withRemoveButton }) => {
	return (
		<Stack spacing={spaces.xxs} direction="row" data-testid="ai-assistant-uploaded-files-list">
			{uploadedAttachments.map((hashName) => (
				<AIUploadFile key={hashName} hashName={hashName} withRemoveButton={withRemoveButton} />
			))}
		</Stack>
	);
};

export default AIUploadFileList;
